import "@/../css/confetti.css";
import { confetti, ConfettiOptions } from "@tsparticles/confetti";

export const DEFAULT_CONFETTI_DURATION_MS = 500;
export const MAX_CONFETTI_DURATION_MS = 3_000;

/**
 * Peer messages arrive as unvalidated JSON off the data channel and the burst
 * emits on every animation frame until its duration elapses, so an absurd value
 * would tie up the other participant's browser for as long as it liked.
 */
export function clampConfettiDuration(durationMs?: number): number {
    if (typeof durationMs !== "number" || !Number.isFinite(durationMs)) {
        return DEFAULT_CONFETTI_DURATION_MS;
    }
    return Math.min(Math.max(durationMs, 0), MAX_CONFETTI_DURATION_MS);
}

export default function playConfetti(
    props?: ConfettiOptions,
    durationMs: number = DEFAULT_CONFETTI_DURATION_MS,
) {
    const end = Date.now() + durationMs;
    (function frame() {
        confetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            ...props,
        });

        confetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            ...props,
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    })();
}

const MEGA_CONFETTI_OPTIONS: ConfettiOptions = {
    ticks: 500,
    scalar: 3,
};

/**
 * The oversized burst the goals board uses when a goal reaches "Accomplished".
 * Particles are 3x normal and live far longer, so the celebration keeps going
 * well past the emission window.
 */
export function playMegaConfetti(durationMs?: number) {
    playConfetti(MEGA_CONFETTI_OPTIONS, durationMs);
}
